import { ParameterConfig, Reference, ReferenceNode, ParameterType } from '@interface/index';
import * as LZString from 'lz-string';

let CommonParameterMap: { [key: string]: ParameterConfig };

const ParameterMapCacheKey = 'ParameterMapCacheKey';

export const ParameterMapStore = {
  set(key: string, value: ParameterConfig) {
    if (!CommonParameterMap) {
      const retrievedCompressedData = localStorage.getItem(ParameterMapCacheKey);
      CommonParameterMap = retrievedCompressedData ? JSON.parse(LZString.decompress(retrievedCompressedData)) : {};
    }

    CommonParameterMap[key] = value;
    try {
      const compressedData = LZString.compress(JSON.stringify(CommonParameterMap));
      window.sessionStorage.setItem(ParameterMapCacheKey, compressedData);
    } catch (err) {
      console.log('parameter map set failed');
    }
  },
  setMany(kvs: { [key: string]: ParameterConfig }) {
    if (!CommonParameterMap) {
      const retrievedCompressedData = localStorage.getItem(ParameterMapCacheKey);
      CommonParameterMap = retrievedCompressedData ? JSON.parse(LZString.decompress(retrievedCompressedData)) : {};
    }

    CommonParameterMap = {
      // Merge kvs with CommonParameterMap
      ...CommonParameterMap,
      ...kvs
    };
    try {
      const compressedData = LZString.compress(JSON.stringify(CommonParameterMap));
      window.sessionStorage.setItem(ParameterMapCacheKey, compressedData);
    } catch (err) {
      console.log('parameter map setMany failed');
    }
  },
  get(key: string) {
    if (!CommonParameterMap) {
      try {

        const retrievedCompressedData = localStorage.getItem(ParameterMapCacheKey);
        CommonParameterMap = retrievedCompressedData ? JSON.parse(LZString.decompress(retrievedCompressedData)) : {};
      } catch (err) {
        console.log('parameter map get failed');
      }
    }
    return CommonParameterMap[key];
  },
  getMany(keys: string[]) {
    if (!CommonParameterMap) {
      try {

        const retrievedCompressedData = localStorage.getItem(ParameterMapCacheKey);
        CommonParameterMap = retrievedCompressedData ? JSON.parse(LZString.decompress(retrievedCompressedData)) : {};
      } catch (err) {
        console.log('parameter map getMany failed');
      }
    }

    const ret: ParameterConfig[] = [];

    for (const key of keys) {
      ret.push(CommonParameterMap[key]);
    }

    return ret;
  },
  getByName(name: string) {
    const all = ParameterMapStore.all();
    for (const p of Object.values(all)) {
      if (p.name === name) {
        return p;
      }
    }

    return undefined;
  },
  all() {
    if (!CommonParameterMap) {
      try {

        const retrievedCompressedData = localStorage.getItem(ParameterMapCacheKey);
        CommonParameterMap = retrievedCompressedData ? JSON.parse(LZString.decompress(retrievedCompressedData)) : {};
      } catch (err) {
        console.log('parameter map all failed');
      }
    }
    return CommonParameterMap;
  },
  clear() {
    if (!CommonParameterMap) {
      const retrievedCompressedData = localStorage.getItem(ParameterMapCacheKey);
      CommonParameterMap = retrievedCompressedData ? JSON.parse(LZString.decompress(retrievedCompressedData)) : {};
    }

    for (const [key, value] of Object.entries(CommonParameterMap)) {
      delete CommonParameterMap[key];
    }
    try {
      const compressedData = LZString.compress(JSON.stringify(CommonParameterMap));
      window.sessionStorage.setItem(ParameterMapCacheKey, compressedData);
    } catch (err) {
      console.log('parameter map clear failed');
    }
  }
};


export function renderReference(reference: Reference) {

  if (!reference) {
    return '';
  }

  return reference.map((node: ReferenceNode) => {
    let name = node.name;
    if (node.showIndex) {
      name = `${name}[${node.index || 0}]`;
    } else if ((node.type === ParameterType.ENTITY ||
      node.type === ParameterType.COMPOSITE ||
      node.type === ParameterType.INTENT) && !name.endsWith('(Type)')) {
      name = `${name}(Type)`;
    }
    return name;
  }).join('.');
}
